/* unplugin-vue-components disabled */import { render } from "./segment.vue?vue&type=template&id=4ad7f7b3&scoped=true"
import script from "./segment.vue?vue&type=script&lang=js"
export * from "./segment.vue?vue&type=script&lang=js"

import "./segment.vue?vue&type=style&index=0&id=4ad7f7b3&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ad7f7b3"],['__file',"src/controls/segment.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4ad7f7b3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4ad7f7b3', __exports__)) {
    api.reload('4ad7f7b3', __exports__)
  }
  
  module.hot.accept("./segment.vue?vue&type=template&id=4ad7f7b3&scoped=true", () => {
    api.rerender('4ad7f7b3', render)
  })

}


export default __exports__